import { Pipe, PipeTransform } from '@angular/core';
import { CMS_END_POINTS } from '../const/api';
import { ConfigService } from '../services/config.service';

@Pipe({
  name: 'imageSource'
})
export class ImageSourcePipe implements PipeTransform {

  constructor(private configService: ConfigService){}

  transform(imageFile: string = ''): string {
    if (!imageFile) return '';

    if (imageFile.startsWith('assets/images/')) return imageFile;
    if (imageFile.startsWith('assets/svgs/')) return imageFile;

    // 
    let result = "woqod"; // default
    // if (typeof window !== 'undefined') {
    //   const pathArray = window.location.pathname.split("/").filter(Boolean); // remove empty strings
    //   if (pathArray.some(segment => segment === "fahes")) result = "fahes";
    //   if (pathArray.some(segment => segment === "qjet")) result = "qjet";      
    // }
    // 

    // Check if the route is an external URL
    if (
      imageFile.startsWith('//') ||
      imageFile.startsWith('http://') ||
      imageFile.startsWith('https://') ||
      imageFile.startsWith('www.')
    ) {
      return imageFile;
    } else if (imageFile === 'loadingImage2') {
      return 'assets/images/default-img-2.gif'
    } else if (imageFile === 'loadingImage') {
      return result === "fahes" ? 'assets/images/Fahes_loader_new.gif' : result === "qjet" ? 'assets/images/Qjet_loader_new.gif' : 'assets/images/default-img.gif'
    } else if (imageFile === 'errorImage') {
      return 'assets/images/error-default.jpeg'
    } else {
      return imageFile ? this.configService.baseURL + CMS_END_POINTS.GET_IMAGE_BY_FILE + "?id=" + imageFile : 'assets/images/default-img.webp';
    }
  }

}
